import type { IconSvgObject } from '@hugeicons/angular';
export * from '@hugeicons/core-free-icons';
import {
  Activity01Icon,
  Add01Icon,
  AddCircleIcon,
  AlarmClockIcon,
  Alert01Icon,
  Archive01Icon,
  ArrowDown01Icon,
  ArrowDownRight01Icon,
  ArrowExpand01Icon,
  ArrowLeft01Icon,
  ArrowLeftRightIcon,
  ArrowReloadHorizontalIcon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  ArrowUpDownIcon,
  ArrowUpRight01Icon,
  Attachment01Icon,
  Award01Icon,
  BarChartIcon,
  BellDotIcon,
  Bookmark01Icon,
  Briefcase02Icon,
  BrushIcon,
  BubbleChatIcon,
  Bug01Icon,
  Building03Icon,
  Calendar01Icon,
  CalendarAdd01Icon,
  CalendarBlock01Icon,
  CalendarCheckIn01Icon,
  Call02Icon,
  CameraVideoIcon,
  Cancel01Icon,
  Cash02Icon,
  CheckListIcon,
  CheckmarkCircle02Icon,
  CheckmarkSquare02Icon,
  CircleArrowUp01Icon,
  CircleIcon,
  CircleUnlock01Icon,
  ClipboardIcon,
  Clock01Icon,
  CloudDownloadIcon,
  CloudIcon,
  CloudUploadIcon,
  CoinsDollarIcon,
  ColorPickerIcon,
  Contact02Icon,
  CpuIcon,
  DatabaseIcon,
  Delete02Icon,
  DeliveryBox01Icon,
  Diamond01Icon,
  Download01Icon,
  DragDropVerticalIcon,
  Edit01Icon,
  EyeIcon,
  File02Icon,
  FilterIcon,
  Flag01Icon,
  FolderArchiveIcon,
  FolderOpenIcon,
  GemIcon,
  Globe02Icon,
  GoogleIcon,
  GridIcon,
  Home03Icon,
  InboxIcon,
  InformationCircleIcon,
  Invoice02Icon,
  KanbanIcon,
  Key01Icon,
  LayerIcon,
  LayoutGridIcon,
  LayoutThreeColumnIcon,
  Layers01Icon,
  Link01Icon,
  ListViewIcon,
  LockIcon,
  Login01Icon,
  Logout01Icon,
  MagicWand01Icon,
  Mail01Icon,
  MailSend01Icon,
  Minimize01Icon,
  MinusSignIcon,
  Moon02Icon,
  MoreHorizontalIcon,
  Notification03Icon,
  NoteIcon,
  NotebookIcon,
  PackageIcon,
  PencilEdit01Icon,
  PinIcon,
  PlayCircleIcon,
  QuestionIcon,
  ReceiptTextIcon,
  RedoIcon,
  Rocket01Icon,
  SchoolIcon,
  Search01Icon,
  SecurityCheckIcon,
  SecurityLockIcon,
  SentIcon,
  Settings02Icon,
  Share01Icon,
  Shield02Icon,
  ShoppingCartIcon,
  SlidersHorizontalIcon,
  SlidersVerticalIcon,
  SparklesIcon,
  StarAward01Icon,
  StoreIcon,
  Sun03Icon,
  TableIcon,
  Tag01Icon,
  Target01Icon,
  Task01Icon,
  TaskDaily01Icon,
  TextAlignCenterIcon,
  TextAlignLeftIcon,
  TruckIcon,
  TypeCursorIcon,
  Upload01Icon,
  UndoIcon,
  UserAccountIcon,
  UserAdd01Icon,
  UserCheck01Icon,
  UserCircleIcon,
  UserGroupIcon,
  UserIcon,
  UserLock01Icon,
  UserMultipleIcon,
  UserStatusIcon,
  Video01Icon,
  ViewIcon,
  ViewOffIcon,
  ViewSidebarLeftIcon,
  WifiIcon,
  WifiOffIcon,
  ZapIcon
} from '@hugeicons/core-free-icons';

/**
 * Every application icon definition belongs here. Components consume named
 * Hugeicons exports or resolver keys from this registry, never SVG geometry.
 */
export const DashboardFilledIcon: IconSvgObject = [
  [
    'path',
    {
      d: 'M3 11.9896V14.5c0 3.2998 0 4.9497 1.02513 5.9749C5.05025 21.5 6.70017 21.5 10 21.5h4c3.2998 0 4.9497 0 5.9749-1.0251C21 19.4497 21 17.7998 21 14.5v-2.5104c0-1.6813 0-2.5219-.3559-3.2496-.3559-.7277-1.0194-1.2438-2.3465-2.2759l-2-1.5556C14.2331 3.30285 13.2009 2.5 12 2.5c-1.2009 0-2.2331.80285-4.29758 2.40855l-2.00001 1.55556C4.37533 7.49628 3.71179 8.01237 3.3559 8.74005 3 9.46773 3 10.3083 3 11.9896ZM7.5 21.5v-5.6c0-2.05 1.1-3.15 3.15-3.15h2.7c2.05 0 3.15 1.1 3.15 3.15v5.6h-9Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      key: '0'
    }
  ]
];

export const ReportsOutlineIcon: IconSvgObject = [
  ['path', { d: 'M7 2h5.35c.8 0 1.57.32 2.13.88l4.64 4.64c.56.56.88 1.33.88 2.13V18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6a4 4 0 0 1 3-4Zm6.5 1.9V7a1 1 0 0 0 1 1h3.1', fill: 'none', stroke: 'currentColor', strokeWidth: '1.25', strokeLinecap: 'round', strokeLinejoin: 'round', key: '0' }],
  ['path', { d: 'M5.9 15.5h4.2V19H5.9v-3.5ZM9.9 11.5h4.2V19H9.9v-7.5ZM13.9 14h4.2v5h-4.2v-5Z', fill: 'currentColor', key: '1' }]
];

export const ReportsFilledIcon: IconSvgObject = [
  [
    'path',
    {
      d: 'M7.25 2.25h3.25V8a2.7 2.7 0 0 0 2.7 2.7h6.55v7.05A4.25 4.25 0 0 1 15.5 22h-7a4.25 4.25 0 0 1-4.25-4.25V6.5a4.25 4.25 0 0 1 3-4.06l.01-.19ZM7 15.1a.9.9 0 0 0-.9.9v2.5a.9.9 0 0 0 .9.9h1a.9.9 0 0 0 .9-.9V16a.9.9 0 0 0-.9-.9H7Zm4-4.1a.9.9 0 0 0-.9.9v6.6a.9.9 0 0 0 .9.9h1a.9.9 0 0 0 .9-.9v-6.6a.9.9 0 0 0-.9-.9h-1Zm4 2.65a.9.9 0 0 0-.9.9v3.95a.9.9 0 0 0 .9.9h1a.9.9 0 0 0 .9-.9v-3.95a.9.9 0 0 0-.9-.9h-1Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      key: '0'
    }
  ],
  ['path', { d: 'M13.1 2.2v4.15a1.35 1.35 0 0 0 1.35 1.35h4.3L13.1 2.2Z', fill: 'currentColor', key: '1' }]
];

export const SubmitReportListOutlineIcon: IconSvgObject = [
  ['path', { d: 'M8 2.75h7c2.9 0 4.75 1.85 4.75 4.75v7c0 2.9-1.85 4.75-4.75 4.75H8c-2.9 0-4.75-1.85-4.75-4.75v-7C3.25 4.6 5.1 2.75 8 2.75Z', fill: 'none', stroke: 'currentColor', strokeWidth: '1.25', strokeLinejoin: 'round', key: '0' }],
  ['path', { d: 'M8.4 7.25a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0ZM8.4 11.25a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0ZM8.4 15.25a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0Z', fill: 'currentColor', stroke: 'none', key: '1' }],
  ['path', { d: 'M10.5 7.25h5M10.5 11.25h4M10.5 15.25H13', fill: 'none', stroke: 'currentColor', strokeWidth: '1.4', strokeLinecap: 'round', key: '2' }],
  ['path', { d: 'M22.5 18.25a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0Z', fill: 'var(--app-color-surface, #171817)', stroke: 'currentColor', strokeWidth: '1.25', key: '3' }],
  ['path', { d: 'M18.25 15.75v5M15.75 18.25h5', fill: 'none', stroke: 'currentColor', strokeWidth: '1.25', strokeLinecap: 'round', key: '4' }]
];

export const SubmitReportListFilledIcon: IconSvgObject = [
  ['path', { d: 'M8 2.75h7c2.9 0 4.75 1.85 4.75 4.75v7c0 2.9-1.85 4.75-4.75 4.75H8c-2.9 0-4.75-1.85-4.75-4.75v-7C3.25 4.6 5.1 2.75 8 2.75ZM7.5 6.4a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7Zm3 .1a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Zm-3 3.9a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7Zm3 .1a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Zm-3 3.9a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7Zm3 .1a.75.75 0 0 0 0 1.5H13a.75.75 0 0 0 0-1.5h-2.5Z', fill: 'currentColor', fillRule: 'evenodd', clipRule: 'evenodd', key: '0' }],
  ['path', { d: 'M22.5 18.25a4.25 4.25 0 1 1-8.5 0 4.25 4.25 0 0 1 8.5 0Z', fill: 'currentColor', key: '1' }],
  ['path', { d: 'M17.15 14.95h2.2v2.2h2.2v2.2h-2.2v2.2h-2.2v-2.2h-2.2v-2.2h2.2v-2.2Z', fill: 'var(--app-shell-sidebar-bg, #171817)', key: '2' }]
];

export const SidebarToggleIcon: IconSvgObject = [
  ['path', { d: 'M8 3.25H4.75a2.5 2.5 0 0 0-2.5 2.5v6.5a2.5 2.5 0 0 0 2.5 2.5H8V3.25Z', fill: 'currentColor', key: '0' }],
  ['rect', { x: '2.25', y: '3.25', width: '12.5', height: '11.5', rx: '2.5', fill: 'none', stroke: 'currentColor', strokeWidth: '1.5', key: '1' }]
];

export const LinkDotsIcon: IconSvgObject = [
  ['circle', { cx: '4.5', cy: '4.5', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '0' }],
  ['circle', { cx: '12', cy: '4.5', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '1' }],
  ['circle', { cx: '19.5', cy: '4.5', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '2' }],
  ['circle', { cx: '4.5', cy: '12', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '3' }],
  ['circle', { cx: '12', cy: '12', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '4' }],
  ['circle', { cx: '19.5', cy: '12', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '5' }],
  ['circle', { cx: '4.5', cy: '19.5', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '6' }],
  ['circle', { cx: '12', cy: '19.5', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '7' }],
  ['circle', { cx: '19.5', cy: '19.5', r: '0.8', fill: 'none', stroke: 'currentColor', strokeWidth: '1.3', key: '8' }]
];

export const TreeBranchesIcon: IconSvgObject = [
  ['path', { d: 'M6 5.25v10.5A3.75 3.75 0 0 0 9.75 19.5H18', fill: 'none', stroke: 'currentColor', strokeWidth: '1.6', strokeLinecap: 'round', strokeLinejoin: 'round', key: '0' }],
  ['path', { d: 'M6 11.25h10.5', fill: 'none', stroke: 'currentColor', strokeWidth: '1.6', strokeLinecap: 'round', key: '1' }],
  ['circle', { cx: '6', cy: '4.5', r: '2.4', fill: 'none', stroke: 'currentColor', strokeWidth: '1.4', key: '2' }],
  ['circle', { cx: '18', cy: '11.25', r: '2.4', fill: 'none', stroke: 'currentColor', strokeWidth: '1.4', key: '3' }],
  ['circle', { cx: '18', cy: '19.5', r: '2.4', fill: 'none', stroke: 'currentColor', strokeWidth: '1.4', key: '4' }]
];

export const SendFilledIcon: IconSvgObject = [
  [
    'path',
    {
      d: 'M22.05 2.26c.57-.3 1.22.2 1.05.82l-4.62 17.55c-.18.7-1.1.85-1.5.25l-4.18-6.24-6.24-4.18c-.6-.4-.45-1.32.25-1.5l17.55-4.62c.62-.17 1.12.48.82 1.05ZM8.72 9.9l4.4 2.95 5.86-5.86L8.72 9.9Zm5.38 1 2.95 4.4 2.91-10.26-5.86 5.86Z',
      fill: 'currentColor',
      key: '0'
    }
  ]
];

const SaveIcon: IconSvgObject = [
  [
    'path',
    {
      class: 'app-icon-save-fill',
      d: 'M5.6 3.25h9.9c.54 0 1.06.22 1.44.6l3.2 3.2c.38.38.6.9.6 1.44V18.4a2.35 2.35 0 0 1-2.35 2.35H5.6a2.35 2.35 0 0 1-2.35-2.35V5.6A2.35 2.35 0 0 1 5.6 3.25Zm2.15 1.8v5.2h8.5v-4l-1.2-1.2h-1.3v3.35h-4.4V5.05h-1.6Zm.85 9.15a1 1 0 0 0-1 1v2.6a1 1 0 0 0 1 1h6.8a1 1 0 0 0 1-1v-2.6a1 1 0 0 0-1-1H8.6Zm1.05 1.35h4.7a.65.65 0 0 1 0 1.3h-4.7a.65.65 0 0 1 0-1.3Z',
      fill: 'currentColor',
      key: '0'
    }
  ],
  [
    'path',
    {
      class: 'app-icon-save-outline',
      d: 'M5.8 4.25h9.3c.4 0 .78.16 1.06.44l3.15 3.15c.28.28.44.66.44 1.06v9.3a1.55 1.55 0 0 1-1.55 1.55H5.8a1.55 1.55 0 0 1-1.55-1.55V5.8A1.55 1.55 0 0 1 5.8 4.25Zm1.45 0v5.5h8.5v-4.1m-7.5 8.6h7.5v5.5h-7.5v-5.5Zm2-10v3.25h3.5V4.25',
      fill: 'none',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.7',
      key: '1'
    }
  ]
];

const ApplyCheckOutlineIcon: IconSvgObject = [
  [
    'path',
    {
      d: 'M12 21.25a9.25 9.25 0 1 1 0-18.5 9.25 9.25 0 0 1 0 18.5Z',
      fill: 'none',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.7',
      key: '0'
    }
  ],
  [
    'path',
    {
      d: 'm8.2 12.35 2.35 2.35 5.25-5.4',
      fill: 'none',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.9',
      key: '1'
    }
  ]
];

const ApplyCheckFillIcon: IconSvgObject = [
  [
    'path',
    {
      d: 'M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5Zm4.6 6.95-5.8 5.95a.9.9 0 0 1-1.28.01L7.4 13.54a.9.9 0 1 1 1.27-1.28l1.47 1.46 5.17-5.3A.9.9 0 1 1 16.6 9.7Z',
      fill: 'currentColor',
      key: '0'
    }
  ]
];

const exactIconMap: Record<string, IconSvgObject> = {
  '123': TypeCursorIcon,
  activity: Activity01Icon,
  alarm: AlarmClockIcon,
  'apply-check-fill': ApplyCheckFillIcon,
  'apply-check-outline': ApplyCheckOutlineIcon,
  archive: Archive01Icon,
  'arrow-clockwise': RedoIcon,
  'arrow-counterclockwise': UndoIcon,
  'arrow-down': ArrowDown01Icon,
  'arrow-down-right': ArrowDownRight01Icon,
  'arrow-down-up': ArrowUpDownIcon,
  'arrow-left': ArrowLeft01Icon,
  'arrow-left-right': ArrowLeftRightIcon,
  'arrow-repeat': ArrowReloadHorizontalIcon,
  'arrow-redo': RedoIcon,
  'arrow-return-left': ArrowLeft01Icon,
  'arrow-undo': UndoIcon,
  'arrow-right': ArrowRight01Icon,
  'arrow-right-short': ArrowRight01Icon,
  'arrow-up': ArrowUp01Icon,
  'arrow-up-circle': CircleArrowUp01Icon,
  'arrow-up-right': ArrowUpRight01Icon,
  'arrows-angle-expand': ArrowExpand01Icon,
  'arrows-collapse': Minimize01Icon,
  'arrows-expand': ArrowExpand01Icon,
  at: Mail01Icon,
  attachment: Attachment01Icon,
  award: Award01Icon,
  'bag-check': ShoppingCartIcon,
  'bar-chart': BarChartIcon,
  'bar-chart-line': BarChartIcon,
  'bar-chart-steps': BarChartIcon,
  bell: BellDotIcon,
  'bell-fill': BellDotIcon,
  'bell-slash': Notification03Icon,
  bezier2: DragDropVerticalIcon,
  bookmark: Bookmark01Icon,
  'bookmark-star': Bookmark01Icon,
  box: PackageIcon,
  'box-arrow-in-down': ArrowDown01Icon,
  'box-arrow-in-right': Login01Icon,
  'box-arrow-right': ArrowRight01Icon,
  'box-arrow-up': Upload01Icon,
  'box-arrow-up-right': ArrowUpRight01Icon,
  'box-seam': DeliveryBox01Icon,
  box2: PackageIcon,
  brightness: Sun03Icon,
  'brightness-alt-high': Sun03Icon,
  briefcase: Briefcase02Icon,
  brush: BrushIcon,
  bug: Bug01Icon,
  building: Building03Icon,
  buildings: Building03Icon,
  bullseye: Target01Icon,
  calendar: Calendar01Icon,
  'calendar-check': CalendarCheckIn01Icon,
  'calendar-date': Calendar01Icon,
  'calendar-event': CalendarAdd01Icon,
  'calendar-plus': CalendarAdd01Icon,
  'calendar-x': CalendarBlock01Icon,
  'calendar2-check': CalendarCheckIn01Icon,
  'calendar2-event': CalendarAdd01Icon,
  'calendar2-plus': CalendarAdd01Icon,
  'calendar2-week': Calendar01Icon,
  calendar3: Calendar01Icon,
  'camera-video': CameraVideoIcon,
  'card-checklist': CheckListIcon,
  'card-text': File02Icon,
  'cart-check': ShoppingCartIcon,
  'cash-coin': CoinsDollarIcon,
  'cash-stack': Cash02Icon,
  chat: BubbleChatIcon,
  'chat-dots': BubbleChatIcon,
  'chat-left': BubbleChatIcon,
  'chat-left-text': BubbleChatIcon,
  'chat-right-text': BubbleChatIcon,
  'chat-square-text': BubbleChatIcon,
  check2: CheckmarkSquare02Icon,
  'check2-all': CheckmarkSquare02Icon,
  'check2-circle': CheckmarkCircle02Icon,
  'check2-square': CheckmarkSquare02Icon,
  'check-circle': CheckmarkCircle02Icon,
  'check-circle-fill': CheckmarkCircle02Icon,
  'check-lg': CheckmarkSquare02Icon,
  'caret-down-fill': ArrowDown01Icon,
  'caret-right-fill': ArrowRight01Icon,
  'caret-up-fill': ArrowUp01Icon,
  circle: CircleIcon,
  'circle-fill': CircleIcon,
  'clipboard-check': CheckListIcon,
  'clipboard-data': ClipboardIcon,
  clock: Clock01Icon,
  'clock-history': Clock01Icon,
  cloud: CloudIcon,
  'cloud-arrow-down': CloudDownloadIcon,
  'cloud-arrow-up': CloudUploadIcon,
  'cloud-check': CloudIcon,
  coin: CoinsDollarIcon,
  'columns-gap': LayoutThreeColumnIcon,
  cpu: CpuIcon,
  'currency-dollar': CoinsDollarIcon,
  database: DatabaseIcon,
  'dash-lg': MinusSignIcon,
  diamond: Diamond01Icon,
  'diagram-2': LayoutGridIcon,
  'diagram-3': LayoutThreeColumnIcon,
  download: Download01Icon,
  dropbox: PackageIcon,
  envelope: Mail01Icon,
  'envelope-paper-heart': Mail01Icon,
  'mail-send': MailSend01Icon,
  eraser: Delete02Icon,
  'exclamation-octagon': Alert01Icon,
  'exclamation-circle': Alert01Icon,
  'exclamation-triangle': Alert01Icon,
  eye: EyeIcon,
  'eye-slash': ViewOffIcon,
  'file-earmark-bar-graph': BarChartIcon,
  'file-earmark-check': File02Icon,
  'file-earmark-text': File02Icon,
  files: File02Icon,
  'filter-circle': FilterIcon,
  flag: Flag01Icon,
  fire: ZapIcon,
  flower1: SparklesIcon,
  'folder-fill': FolderArchiveIcon,
  'folder2-open': FolderOpenIcon,
  funnel: FilterIcon,
  gear: Settings02Icon,
  gem: GemIcon,
  'geo-alt': PinIcon,
  globe: Globe02Icon,
  'globe-americas': Globe02Icon,
  google: GoogleIcon,
  'graph-up': BarChartIcon,
  'graph-up-arrow': BarChartIcon,
  grid: GridIcon,
  'grip-vertical': DragDropVerticalIcon,
  home: Home03Icon,
  'home-03': Home03Icon,
  hammer: Settings02Icon,
  'hdd-network': DatabaseIcon,
  'heart-pulse': Activity01Icon,
  'hourglass-split': Clock01Icon,
  info: InformationCircleIcon,
  'info-circle': InformationCircleIcon,
  'journal-check': NotebookIcon,
  'journal-text': NoteIcon,
  kanban: KanbanIcon,
  key: Key01Icon,
  layers: LayerIcon,
  'layout-sidebar': ViewSidebarLeftIcon,
  'layout-sidebar-inset': ViewSidebarLeftIcon,
  'layout-sidebar-reverse': ViewSidebarLeftIcon,
  'layout-text-window': LayoutGridIcon,
  'layout-text-window-reverse': LayoutGridIcon,
  'layout-three-columns': LayoutThreeColumnIcon,
  'lightning-charge': ZapIcon,
  'lightning-fill': ZapIcon,
  'link-45deg': Link01Icon,
  'link-dots': LinkDotsIcon,
  list: ListViewIcon,
  'list-check': CheckListIcon,
  'list-ol': ListViewIcon,
  'list-task': Task01Icon,
  'list-ul': ListViewIcon,
  lock: LockIcon,
  'lock-fill': SecurityLockIcon,
  'magic-wand': MagicWand01Icon,
  magic: MagicWand01Icon,
  moon: Moon02Icon,
  'moon-stars': Moon02Icon,
  mortarboard: SchoolIcon,
  'node-plus': AddCircleIcon,
  palette: ColorPickerIcon,
  'palette-fill': ColorPickerIcon,
  paperclip: Attachment01Icon,
  pen: Edit01Icon,
  highlighter: PencilEdit01Icon,
  pencil: PencilEdit01Icon,
  'pencil-square': PencilEdit01Icon,
  percent: CoinsDollarIcon,
  people: UserMultipleIcon,
  'people-fill': UserMultipleIcon,
  person: UserIcon,
  'person-add': UserAdd01Icon,
  'person-badge': UserAccountIcon,
  'person-bounding-box': UserAccountIcon,
  'person-check': UserCheck01Icon,
  'person-circle': UserCircleIcon,
  'person-fill': UserIcon,
  'person-gear': UserStatusIcon,
  'person-lock': UserLock01Icon,
  'person-lines-fill': UserStatusIcon,
  'person-plus': UserAdd01Icon,
  'pie-chart': BarChartIcon,
  'pin-angle': PinIcon,
  plus: Add01Icon,
  'plus-circle': AddCircleIcon,
  'plus-lg': Add01Icon,
  'plus-square': AddCircleIcon,
  'plus-square-fill': AddCircleIcon,
  'question-circle': QuestionIcon,
  quote: NoteIcon,
  'record-circle': CircleIcon,
  receipt: ReceiptTextIcon,
  'rocket-takeoff': Rocket01Icon,
  school: SchoolIcon,
  save: SaveIcon,
  search: Search01Icon,
  sent: SentIcon,
  'sent-fill': SendFilledIcon,
  send: Share01Icon,
  'send-fill': Share01Icon,
  share: Share01Icon,
  'shield-check': SecurityCheckIcon,
  'shield-exclamation': Shield02Icon,
  'shield-fill-exclamation': Shield02Icon,
  'shield-lock': SecurityLockIcon,
  shop: StoreIcon,
  'sign-merge-right': Share01Icon,
  signpost: PinIcon,
  'slash-circle': Cancel01Icon,
  'slash-lg': Cancel01Icon,
  sliders2: SlidersHorizontalIcon,
  sliders: SlidersHorizontalIcon,
  'sliders2-vertical': SlidersVerticalIcon,
  star: StarAward01Icon,
  stars: SparklesIcon,
  stopwatch: Clock01Icon,
  sun: Sun03Icon,
  table: TableIcon,
  tag: Tag01Icon,
  tags: Tag01Icon,
  'tree-branches': TreeBranchesIcon,
  telephone: Call02Icon,
  'text-center': TextAlignCenterIcon,
  'text-left': TextAlignLeftIcon,
  'three-dots': MoreHorizontalIcon,
  'three-dots-vertical': MoreHorizontalIcon,
  tools: Settings02Icon,
  trash: Delete02Icon,
  trash3: Delete02Icon,
  trophy: Award01Icon,
  truck: TruckIcon,
  type: TypeCursorIcon,
  'type-bold': TypeCursorIcon,
  'type-italic': TypeCursorIcon,
  'ui-checks-grid': CheckListIcon,
  unlock: CircleUnlock01Icon,
  upc: Search01Icon,
  'upc-scan': Search01Icon,
  upload: Upload01Icon,
  view: ViewIcon,
  'view-off': ViewOffIcon,
  'view-sidebar-left': ViewSidebarLeftIcon,
  wallet2: CoinsDollarIcon,
  wifi: WifiIcon,
  'wifi-1': WifiIcon,
  'wifi-off': WifiOffIcon,
  windows: GridIcon,
  'wrench-adjustable-circle': Settings02Icon,
  x: Cancel01Icon,
  'x-circle': Cancel01Icon,
  'x-lg': Cancel01Icon,
  'x-octagon': Cancel01Icon
};

export interface AppIconSpec {
  readonly outline: IconSvgObject;
  readonly filled: IconSvgObject;
  readonly size: number;
  readonly strokeWidth: number;
}

const appIconSpecs: Readonly<Record<string, AppIconSpec>> = Object.freeze({
  'nav-dashboard': {
    outline: Home03Icon,
    filled: DashboardFilledIcon,
    size: 18,
    strokeWidth: 0.95
  },
  'nav-salary-reports': {
    outline: ReportsOutlineIcon,
    filled: ReportsFilledIcon,
    size: 18,
    strokeWidth: 0.95
  },
  'nav-submit-report': {
    outline: SubmitReportListOutlineIcon,
    filled: SubmitReportListFilledIcon,
    size: 18,
    strokeWidth: 0.95
  }
});

export function resolveAppIconSpec(name: string): AppIconSpec {
  const spec = appIconSpecs[name];
  if (spec) return spec;
  const outline = resolveAppIconDefinition(name);
  return { outline, filled: outline, size: 18, strokeWidth: 0.95 };
}

export const APP_ICON_NAME_OPTIONS: readonly string[] = Object.freeze(Object.keys(exactIconMap));

function includesAny(value: string, tokens: readonly string[]): boolean {
  return tokens.some(token => value.includes(token));
}

function normalizeIconKey(iconName: string | null | undefined): string {
  return iconName?.trim().toLowerCase().replace(/^bi-/, '') ?? '';
}

export function resolveAppIconDefinition(iconName: string | null | undefined): IconSvgObject {
  const normalized = normalizeIconKey(iconName);
  if (!normalized) {
    return CircleIcon;
  }

  const exactIcon = exactIconMap[normalized];
  if (exactIcon) {
    return exactIcon;
  }

  if (includesAny(normalized, ['chevron-left', 'arrow-left', 'back'])) return ArrowLeft01Icon;
  if (includesAny(normalized, ['chevron-right', 'arrow-right', 'forward'])) return ArrowRight01Icon;
  if (includesAny(normalized, ['chevron-down', 'arrow-down'])) return ArrowDown01Icon;
  if (includesAny(normalized, ['chevron-up', 'arrow-up'])) return ArrowUp01Icon;
  if (normalized.includes('calendar')) return Calendar01Icon;
  if (includesAny(normalized, ['check-circle', 'check2-circle'])) return CheckmarkCircle02Icon;
  if (includesAny(normalized, ['check', 'check2', 'checkmark', 'done'])) {
    return CheckmarkSquare02Icon;
  }
  if (includesAny(normalized, ['plus', 'add'])) return Add01Icon;
  if (includesAny(normalized, ['minus', 'dash'])) return MinusSignIcon;
  if (includesAny(normalized, ['trash', 'delete', 'remove'])) return Delete02Icon;
  if (includesAny(normalized, ['person', 'user'])) return UserIcon;
  if (normalized.includes('people')) return UserMultipleIcon;
  if (includesAny(normalized, ['mail', 'envelope'])) return Mail01Icon;
  if (includesAny(normalized, ['phone', 'call', 'telephone'])) return Call02Icon;
  if (includesAny(normalized, ['message', 'chat', 'comment'])) return BubbleChatIcon;
  if (includesAny(normalized, ['search', 'zoom'])) return Search01Icon;
  if (includesAny(normalized, ['gear', 'settings', 'sliders', 'wrench', 'tools'])) {
    return Settings02Icon;
  }
  if (includesAny(normalized, ['funnel', 'filter'])) return FilterIcon;
  if (includesAny(normalized, ['folder', 'archive'])) return FolderOpenIcon;
  if (includesAny(normalized, ['file', 'journal', 'note', 'card-text'])) return File02Icon;
  if (includesAny(normalized, ['chart', 'graph', 'analytics'])) return BarChartIcon;
  if (includesAny(normalized, ['cash', 'coin', 'wallet', 'dollar', 'receipt', 'invoice'])) {
    return CoinsDollarIcon;
  }
  if (includesAny(normalized, ['tag', 'bookmark'])) return Tag01Icon;
  if (normalized.includes('flag')) return Flag01Icon;
  if (includesAny(normalized, ['star', 'award', 'trophy'])) return StarAward01Icon;
  if (includesAny(normalized, ['diamond', 'gem'])) return GemIcon;
  if (includesAny(normalized, ['moon', 'night'])) return Moon02Icon;
  if (includesAny(normalized, ['sun', 'brightness'])) return Sun03Icon;
  if (includesAny(normalized, ['wifi', 'signal'])) return WifiIcon;
  if (includesAny(normalized, ['cloud'])) return CloudIcon;
  if (includesAny(normalized, ['box', 'package', 'delivery'])) return PackageIcon;
  if (includesAny(normalized, ['building', 'office'])) return Building03Icon;
  if (includesAny(normalized, ['shop', 'store'])) return StoreIcon;
  if (includesAny(normalized, ['cart', 'bag'])) return ShoppingCartIcon;
  if (includesAny(normalized, ['truck', 'delivery'])) return TruckIcon;
  if (includesAny(normalized, ['link', 'share'])) return Link01Icon;
  if (includesAny(normalized, ['clipboard'])) return ClipboardIcon;
  if (includesAny(normalized, ['kanban', 'task'])) return Task01Icon;
  if (includesAny(normalized, ['grid', 'layout'])) return GridIcon;
  if (includesAny(normalized, ['table'])) return TableIcon;
  if (includesAny(normalized, ['database'])) return DatabaseIcon;
  if (includesAny(normalized, ['shield'])) return Shield02Icon;
  if (includesAny(normalized, ['lock'])) return LockIcon;
  if (includesAny(normalized, ['pin'])) return PinIcon;
  if (includesAny(normalized, ['play'])) return PlayCircleIcon;
  if (includesAny(normalized, ['bug'])) return Bug01Icon;
  if (includesAny(normalized, ['cpu'])) return CpuIcon;
  if (includesAny(normalized, ['magic', 'spark', 'flower', 'smile'])) return SparklesIcon;
  if (includesAny(normalized, ['video'])) return Video01Icon;
  if (includesAny(normalized, ['bell', 'notification'])) return Notification03Icon;
  if (includesAny(normalized, ['home', 'inbox'])) return InboxIcon;
  if (includesAny(normalized, ['info'])) return InformationCircleIcon;
  if (includesAny(normalized, ['question'])) return QuestionIcon;
  if (includesAny(normalized, ['alert', 'exclamation', 'warning'])) return Alert01Icon;
  if (includesAny(normalized, ['globe', 'world'])) return Globe02Icon;
  if (includesAny(normalized, ['google'])) return GoogleIcon;
  if (includesAny(normalized, ['palette', 'color'])) return ColorPickerIcon;
  if (includesAny(normalized, ['edit', 'pencil', 'pen'])) return PencilEdit01Icon;
  if (includesAny(normalized, ['download'])) return Download01Icon;
  if (includesAny(normalized, ['upload'])) return Upload01Icon;
  if (includesAny(normalized, ['briefcase'])) return Briefcase02Icon;
  if (includesAny(normalized, ['rocket'])) return Rocket01Icon;
  if (includesAny(normalized, ['target', 'bullseye'])) return Target01Icon;
  if (includesAny(normalized, ['school'])) return SchoolIcon;

  return CircleIcon;
}
